import {
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const projectIssueCategoriesApi = createApi({
  reducerPath: "projectIssueCategoriesApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectIssueCategories: build.query({
      query: () => 'projectIssueCategories',
      transformResponse: (response: { data: { id: number; code: string; name: string }[] }) => response.data,
    }),
  }),
});

export const { useGetProjectIssueCategoriesQuery } = projectIssueCategoriesApi;
